export const ACCOUNT_TYPES = [
  {
    id: 'PARTICULAR',
    role: 'CLIENT',
    title: 'Particular',
    eyebrow: 'BUSCÁ, GUARDÁ O PUBLICÁ',
    description: 'Encontrá oportunidades, seguí tus favoritas y publicá gratis si lo necesitás.',
  },
  {
    id: 'INMOBILIARIA',
    role: 'PROFESSIONAL',
    title: 'Inmobiliaria',
    eyebrow: 'EQUIPO PROFESIONAL',
    description: 'Gestioná cartera, contactos y oportunidades desde un único espacio.',
  },
  {
    id: 'DESARROLLADORA',
    role: 'PROFESSIONAL',
    title: 'Desarrolladora',
    eyebrow: 'PROYECTOS Y EMPRENDIMIENTOS',
    description: 'Presentá desarrollos, unidades y campañas con acompañamiento comercial.',
  },
];

export const PLANS_BY_ACCOUNT = {
  PARTICULAR: [
    { id: 'FREE', name: 'NIDO Esencial', price: 0, limit: 1, featured: 0, description: 'Tu primera propiedad publicada gratis.', features: ['1 publicación activa', 'Sin costo ni tarjeta', 'Consultas desde tu panel'] },
    { id: 'SIMPLE', name: 'NIDO Simple', price: 54900, limit: 1, featured: 0, description: 'Una publicación adicional con visibilidad estándar.', features: ['1 publicación adicional', 'Visibilidad estándar', 'Renovación mensual'] },
    { id: 'DESTACADO', name: 'NIDO Destacada', price: 109900, limit: 1, featured: 1, recommended: true, description: 'Más exposición cuando coincide con una búsqueda.', features: ['Prioridad en resultados afines', 'Mayor presencia en recomendaciones', 'Renovación mensual'] },
    { id: 'SUPERDESTACADO', name: 'NIDO Máxima', price: 179900, limit: 1, featured: 3, description: 'La mayor exposición para una propiedad particular.', features: ['Prioridad superior en resultados afines', 'Elegible para destacados por zona', 'Renovación mensual'] },
  ],
  INMOBILIARIA: [
    { id: 'PACK_5', name: 'NIDO Inicio', price: 173332.50, limit: 5, featured: 0, description: 'Cinco publicaciones para empezar a mostrar tu cartera.', features: ['5 publicaciones Simples', 'Visibilidad estándar', 'Renovación mensual'] },
    { id: 'PACK_10', name: 'NIDO Cartera', price: 243940.84, limit: 10, featured: 2, recommended: true, description: 'Una cartera equilibrada para crecer.', features: ['10 publicaciones activas', '2 créditos de destaque', 'Renovación mensual'] },
    { id: 'PACK_DESTACADOS', name: 'NIDO Pro', price: 412084.86, limit: 10, featured: 10, description: 'Alta visibilidad para diez propiedades.', features: ['10 publicaciones destacadas', 'Mayor presencia en recomendaciones', 'Renovación mensual'] },
    { id: 'PACK_SUPER', name: 'NIDO Máxima', price: 482920.68, limit: 5, featured: 15, description: 'Máxima exposición para cinco propiedades.', features: ['5 publicaciones superdestacadas', 'Elegibles para destacados por zona', 'Renovación mensual'] },
  ],
  DESARROLLADORA: [
    { id: 'ZONE_DESTACADO', name: 'Destacado por zona', price: 167496.67, limit: 1, featured: 1, description: 'Presencia destacada dentro de una zona específica.', features: ['Prioridad moderada en resultados de la zona', 'Mayor presencia en recomendaciones afines', 'Identificación transparente'] },
    { id: 'ZONE_SUPER', name: 'Superdestacado por zona', price: 267994.43, limit: 1, featured: 3, recommended: true, description: 'Máxima exposición dentro de una zona específica.', features: ['Prioridad superior en resultados de la zona', 'Elegible para Destacados por zona', 'Identificación patrocinada'] },
  ],
};

export const formatPrice = (price) => price === null
  ? 'A medida'
  : price === 0
    ? 'Gratis'
    : new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price);
